// extracted by mini-css-extract-plugin
export default {"wrapper":"C1-z","play":"D1-z"};